import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [{ id: 'auditTypeName', label: t('Master-data.hierarchy.detail.production.zone.table-1-col-1') }];
